import React from "react"
import {
  useEnterpriseGetOne,
  useMainEnterpriseId,
} from "../../../../../../hooks/enterprise"
import LayoutMain from "../../../../../../components/Layouts/LayoutMain"
import HeaderSelect from "../../../../../../components/Headers/HeaderSelect"
import { useShopGetOne, useShopId } from "../../../../../../hooks/shop"
import LayoutLoadingAuthRequired from "../../../../../../components/Layouts/LayoutLoadingAuthRequired"
import NavMainMenu from "../../../../../../components/Navs/NavMainMenu"

const Title = "Выберите действие"

function MainMenu() {
  const enterpriseId = useMainEnterpriseId()
  const shopId = useShopId()

  const {
    enterprise,
    isLoading: isLoadingEnterprise,
    isError: isErrorEnterprise,
  } = useEnterpriseGetOne(enterpriseId)
  const { isLoading: isLoadingShop, isError: isErrorShop } = useShopGetOne(
    enterpriseId,
    shopId
  )

  if (
    isLoadingEnterprise ||
    isLoadingShop ||
    isErrorEnterprise ||
    isErrorShop
  ) {
    return (
      <React.Fragment>
        <LayoutLoadingAuthRequired
          isLoading={isLoadingEnterprise || isLoadingShop}
          isError={isErrorEnterprise || isErrorShop}
        />
      </React.Fragment>
    )
  }

  return (
    <React.Fragment>
      <LayoutMain title={Title}>
        <HeaderSelect name={enterprise?.title} title={"Выберите операцию"} />

        <div className="mx-auto flex max-w-xl flex-1 flex-col justify-center px-8 pb-8">
          <NavMainMenu />
        </div>
      </LayoutMain>
    </React.Fragment>
  )
}

export default MainMenu
